/* eslint-disable no-await-in-loop */
import loadingImage from 'utils/images/loadingImage';
import { AiService } from 'services/aiService';
import { IBatchData } from 'types';

import { IMAGE_MIME_TYPES } from '../configs';

type TExportImage = {name?: string; url: string}

const convertBatchDataImagesFormat = async (selectedData: IBatchData[], format: IMAGE_MIME_TYPES): Promise<TExportImage[]> => {
  const resultData: TExportImage[] = [];
  for (const data of selectedData) {
    if (format === data.result.type) {
      resultData.push({
        name: data.name,
        url: data.result.src,
      });
    } else {
      const image = await loadingImage(data.result.src);
      const blob = await AiService.downloadImage(image, image.width, image.height, format);

      if (!blob) {
        resultData.push({
          name: data.name,
          url: data.result.src,
        });
      } else {
        const url = URL.createObjectURL(blob);

        resultData.push({
          name: data.name,
          url,
        });
      }
    }
  }
  return resultData;
};

export default convertBatchDataImagesFormat;
